export default __webpack_public_path__ + "static/media/Analytics.d7307bfb.png";